/**
 * PROSHOP — Skeleton des vignettes produit.
 * Tant que l'image d'une carte n'est pas chargée, son média affiche un shimmer (CSS).
 * Ce script ajoute `.is-loaded` au média dès que l'<img> est prête → le shimmer s'efface.
 * Couvre le chargement initial ET les nouvelles cartes injectées par WP Grid Builder (AJAX).
 */
(function () {
    'use strict';

    function markLoaded(img) {
        var media = img.closest('.pdw-product-card-media');
        if (media) {
            media.classList.add('is-loaded');
        }
    }

    function process(root) {
        var scope = root && root.querySelectorAll ? root : document;
        scope.querySelectorAll('.pdw-product-card-media img').forEach(function (img) {
            var media = img.closest('.pdw-product-card-media');
            if (!media || media.classList.contains('is-loaded')) {
                return;
            }
            if (img.complete && img.naturalWidth > 0) {
                markLoaded(img);
                return;
            }
            img.addEventListener('load', function () { markLoaded(img); }, { once: true });
            img.addEventListener('error', function () { markLoaded(img); }, { once: true }); // pas de shimmer infini si l'image échoue
        });
    }

    if (document.readyState !== 'loading') {
        process();
    } else {
        document.addEventListener('DOMContentLoaded', function () { process(); });
    }

    // nouvelles cartes après filtrage / tri / pagination AJAX (WP Grid Builder)
    if (window.jQuery) {
        jQuery(document.body).on('wpgb.loaded wpgb.appended', function () { process(); });
    }
})();
